import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DialogTypeEnum } from '@nttp/enum/common-dialog-type.enum';

@Component({
    selector: 'np-common-dialog',
    templateUrl: './common-dialog.component.html',
    styleUrls: ['./common-dialog.component.scss']
})

export class CommonDialogComponent {

    dialogType = DialogTypeEnum;

    constructor(
        public dialogRef: MatDialogRef<CommonDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private router: Router
    ) { }

    closeDialog() {
        if (this.data.routingUrl) {
            this.router.navigate([`${this.data.routingUrl}`]);
        }
    }
}
